import { render, staticRenderFns } from "./unarchived-modal.vue?vue&type=template&id=72193b1a&scoped=true&"
import script from "./unarchived-modal.vue?vue&type=script&lang=js&"
export * from "./unarchived-modal.vue?vue&type=script&lang=js&"
import style0 from "./unarchived-modal.vue?vue&type=style&index=0&id=72193b1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72193b1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
